/** INFORMATION_ACTION */
export const INFORMATION_ACTION = 'reveal';

/** ACCORDION_INFORMATION_UI_TYPE */
export const ACCORDION_INFORMATION_UI_TYPE = 'hs article';

/** ACCORDION_INFORMATION_TRIGGER */
export const ACCORDION_INFORMATION_TRIGGER = 'accordion';

/** SLIDER_INFORMATION_TRIGGER */
export const SLIDER_INFORMATION_TRIGGER = 'slider';

/** SLIDER__INFORMATION_UI_TYPE */
export const SLIDER__INFORMATION_UI_TYPE = 'hs troubleshooter';
